const orderHistory = [
    {
        id: 1,
        active: true,
        packages: 'Esimiestyo 1',
        date: '22.12.2020',
        details: [
            {
                label: 'Hinta',
                data: ' 99e/kk'
            },
            {
                label: 'Kaytetty alennuskoodi',
                data: '30 paivaa illaiseksi'
            },
            {
                label: 'Peruutettu peruutupaiva',
                data: '23.12.2020'
            },
            {
                label: 'Peruutettu aattymispaiva',
                data: '23.12.2020'
            },
            {
                label: 'Laskutustapa',
                data: 'Verkkolasku'
            }
        ]
    },
    {
        id: 2,
        active: false,
        packages: 'Esimiestyo 2',
        date: '22.12.2020',
        details: [
            {
                label: 'Hinta',
                data: ' 99e/kk'
            },
            {
                label: 'Kaytetty alennuskoodi',
                data: '30 paivaa illaiseksi'
            },
            {
                label: 'Peruutettu peruutupaiva',
                data: '23.12.2020'
            },
            {
                label: 'Peruutettu aattymispaiva',
                data: '23.12.2020'
            },
            {
                label: 'Laskutustapa',
                data: 'Verkkolasku'
            }
        ]
    },
    {
        id: 3,
        active: false,
        packages: 'Esimiestyo 3',
        date: '22.12.2020',
        details: [
            {
                label: 'Hinta',
                data: ' 99e/kk'
            },
            {
                label: 'Kaytetty alennuskoodi',
                data: '30 paivaa illaiseksi'
            },
            {
                label: 'Peruutettu peruutupaiva',
                data: '23.12.2020'
            },
            {
                label: 'Peruutettu aattymispaiva',
                data: '23.12.2020'
            },
            {
                label: 'Laskutustapa',
                data: 'Verkkolasku'
            }
        ]
    }
]

const currentOrder = {
    status: 'Aktiivinen',
    packages: 'O356, Palkka',
    active: true
}

export async function getOrderHistory () {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(orderHistory)
        }, 1000)
    })
}

export async function getCurrentOrder () {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(currentOrder)
        }, 1000)
    })
}
